module.exports = __webpack_public_path__ + "static/media/_ceuta.6ec6aa4c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/_ceuta.svg
// module id = 2309
// module chunks = 7